import angular = require("angular");

export function initialize(module: ng.IModule) {
    module.controller("PersonsController", PersonsController);

    PersonsController.$inject = ["$log", "persons", "$state", "serviceConfig"];
}

interface PersonsUISettings {
    searchText: string;
}

var personsUISettings = <PersonsUISettings> {  };

function PersonsController(
    $log: ng.ILogService,
    persons,
    $state: ng.ui.IStateService,
    serviceConfig) {

    var vm = this;
    vm.uiSettings = personsUISettings;
    vm.persons = persons[0].results;
    vm.searchText = "";
    vm.search = search;
    vm.navigateToPerson = navigateToPerson;
    vm.webApiUrl = serviceConfig.webApiUrl;

    activate();

    function activate() {
        $log.info("Persons Controller up and running...");
    }

    function search(person) {
        return (angular.lowercase(person.Name).indexOf(angular.lowercase(vm.uiSettings.searchText) || '') !== -1);
    }
    
    function navigateToPerson(person) {
        $state.go("app.resources.persons.detail", { personId: person.Id });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons.controller.ts